












































































































































































import 'vue2-timepicker/dist/VueTimepicker.css'
import {
  computed,
  defineComponent,
  reactive,
  SetupContext,
  Ref,
  watch,
} from '@vue/composition-api'
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment'

import { ChainStoreState } from '@/types/store'
import { UserRole } from '@/types/user'

import useVuex from '@/utils/useVuex'
import { dateToDisplay } from '@/utils/dateFormatter'

import { AppInput, AppAutocomplete } from '@/components/atoms'
import { DatePicker, TimePicker } from '@/components/molecules'
import { ChainStoreEntity } from '../../../../api/@types'
import { ISpecialOffer, ISpecialOfferReceipt } from '@/types/special-offer'
import { ChainStore } from '@/types/shop'

type Props = {
  specialOfferReceipt: ISpecialOfferReceipt
  specialOffer: ISpecialOffer
}

export default defineComponent({
  name: 'SpecialOfferReceiptFormTable',
  components: {
    VueTimepicker,
    AppInput,
    AppAutocomplete,
    DatePicker,
    TimePicker,
  },
  props: {
    specialOfferReceipt: {
      type: Object,
      default: () => ({}),
    },
    specialOffer: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context: SetupContext) {
    const store = context.root.$store

    const state = reactive<{
      chainStores: Ref<ChainStoreEntity[]>
      chainStoreChoice: { name: string; id: number; other: string }
      itemChoices: { index: number; name: string; id: number; other: string }[]
      itemChoiceSeconds: {
        index: number
        name: string
        id: number
        other: string
      }[]
    }>({
      chainStores: useVuex<ChainStoreState['chainStores']>(
        context,
        () => store.getters['chainStore/allChainStores'],
      ),
      chainStoreChoice: { name: '', id: -1, other: '' },
      itemChoices: [{ index: 0, name: '', id: -1, other: '' }],
      itemChoiceSeconds: [{ index: 0, name: '', id: -1, other: '' }],
    })

    const setChainStoreChoice = () => {
      const found = state.chainStores.find(
        cs => cs.name === props.specialOfferReceipt.chainStoreName,
      )
      if (found) {
        state.chainStoreChoice = { name: found.name, id: found.id, other: '' }
      } else {
        state.chainStoreChoice = {
          name: props.specialOfferReceipt.chainStoreName || '',
          id: props.specialOfferReceipt.chainStoreName ? 0 : -1,
          other: props.specialOfferReceipt.chainStoreName || '',
        }
      }
    }
    const setItemNames = () => {
      state.itemChoices = state.itemChoices.map(itemChoice => {
        const found = props.specialOffer.itemNames.find(
          name => name === props.specialOfferReceipt.itemName,
        )
        if (found) {
          return { ...itemChoice, name: found, id: 1, other: '' }
        } else {
          return {
            ...itemChoice,
            name: props.specialOfferReceipt.itemName || '',
            id: props.specialOfferReceipt.itemName ? 0 : -1,
            other: props.specialOfferReceipt.itemName || '',
          }
        }
      })
    }
    const setItemNameSeconds = () => {
      state.itemChoiceSeconds = state.itemChoiceSeconds.map(
        itemChoiceSecond => {
          const found = props.specialOffer.itemNameSeconds.find(
            name => name === props.specialOfferReceipt.itemNameSecond,
          )
          if (found) {
            return { ...itemChoiceSecond, name: found, id: 1, other: '' }
          } else {
            return {
              ...itemChoiceSecond,
              name: props.specialOfferReceipt.itemNameSecond || '',
              id: props.specialOfferReceipt.itemNameSecond ? 0 : -1,
              other: props.specialOfferReceipt.itemNameSecond || '',
            }
          }
        },
      )
    }
    setChainStoreChoice()
    setItemNames()
    setItemNameSeconds()
    watch(
      () => props.specialOfferReceipt.id,
      _ => {
        setChainStoreChoice()
        setItemNames()
        setItemNameSeconds()
      },
    )

    const chainStores = computed(() => {
      const _chainStores = [
        ...state.chainStores
          .filter(cs => props.specialOffer.chainStoreNames.includes(cs.name))
          .map(({ name, id }) => ({ name, id })),
      ].sort((prev, next) => (prev.name < next.name ? -1 : 1))
      // if (props.specialOffer.canFreeChainStoreName) {
      _chainStores.push({ name: '上記以外のチェーン', id: 0 })
      // }
      return _chainStores
    })

    const items = computed(() => {
      const _items = [
        ...props.specialOffer.itemNames.map(i => ({ id: 1, name: i })),
      ]
      // if (props.specialOffer.canFreeItemName) {
      _items.push({ name: '上記以外の商品', id: 0 })
      // }
      return _items
    })
    const itemSeconds = computed(() => {
      const _itemSeconds = [
        ...props.specialOffer.itemNameSeconds.map(i => ({ id: 1, name: i })),
      ]
      // if (props.specialOffer.canFreeItemName) {
      _itemSeconds.push({ name: '上記以外の商品', id: 0 })
      // }
      return _itemSeconds
    })

    const onChangeChainStoreName = (chainStoreChoice?: {
      name: string
      id: number
      other: string
    }) => {
      const newSpecialOfferReceipt = {
        ...props.specialOfferReceipt,
        chainStoreName: chainStoreChoice ? chainStoreChoice.name : '',
      }
      if (chainStoreChoice) {
        state.chainStoreChoice = chainStoreChoice
      }
      context.emit('update:specialOfferReceipt', newSpecialOfferReceipt)
    }

    const onSelectChainStore = (cs?: ChainStore): void => {
      onChangeChainStoreName(
        cs ? { name: cs.name, id: cs.id, other: cs.name } : undefined,
      )
    }

    const onChangeChainStoreOther = (name: string): void => {
      onChangeChainStoreName({ name, id: 0, other: name })
    }

    const onChangeStoreName = (storeName: string) => {
      const newSpecialOfferReceipt = {
        ...props.specialOfferReceipt,
        storeName,
      }
      context.emit('update:specialOfferReceipt', newSpecialOfferReceipt)
    }

    const onChangePhone = (phone: string) => {
      const newSpecialOfferReceipt = {
        ...props.specialOfferReceipt,
        phone,
      }
      context.emit('update:specialOfferReceipt', newSpecialOfferReceipt)
    }

    const onKeyupPhone = async (e: any) => {
      if (e.isComposing) {
        return
      }
      e.target.value = e.target.value
        .replace(/[ー－]/g, '-')
        .replace(/[０-９]/g, (s: string) => {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
        })
        .replace(/[^-\d]/g, '')

      const phone: string = e.target.value
      onChangePhone(phone)
    }

    const onSelectDateTime = (dateTime: Date) => {
      const newSpecialOfferReceipt = {
        ...props.specialOfferReceipt,
        dateTime,
      }
      context.emit('update:specialOfferReceipt', newSpecialOfferReceipt)
    }

    const onChangeItemName = (itemChoice: {
      index: number
      name: string
      id: number
      other: string
    }) => {
      const newSpecialOfferReceipt = {
        ...props.specialOfferReceipt,
        itemName: itemChoice.name,
      }
      state.itemChoices = state.itemChoices.map(ic => {
        if (ic.index === itemChoice.index) {
          return itemChoice
        }
        return ic
      })
      context.emit('update:specialOfferReceipt', newSpecialOfferReceipt)
    }
    const onChangeItemNameSecond = (itemChoiceSecond: {
      index: number
      name: string
      id: number
      other: string
    }) => {
      const newSpecialOfferReceipt = {
        ...props.specialOfferReceipt,
        itemNameSecond: itemChoiceSecond.name,
      }
      state.itemChoiceSeconds = state.itemChoiceSeconds.map(ic => {
        if (ic.index === itemChoiceSecond.index) {
          return itemChoiceSecond
        }
        return ic
      })
      context.emit('update:specialOfferReceipt', newSpecialOfferReceipt)
    }

    const onSelectItemName = (
      item: { name: string; id: number } | undefined,
      itemChoice: { index: number; name: string; id: number },
    ): void => {
      if (item === undefined) {
        onChangeItemName({ ...itemChoice, name: '', id: -1, other: '' })
        return
      }
      onChangeItemName({
        ...itemChoice,
        name: item.name,
        id: item.id,
        other: item.name,
      })
    }
    const onSelectItemNameSecond = (
      itemSecond: { name: string; id: number } | undefined,
      itemChoiceSecond: { index: number; name: string; id: number },
    ): void => {
      if (itemSecond === undefined) {
        onChangeItemNameSecond({
          ...itemChoiceSecond,
          name: '',
          id: -1,
          other: '',
        })
        return
      }
      onChangeItemNameSecond({
        ...itemChoiceSecond,
        name: itemSecond.name,
        id: itemSecond.id,
        other: itemSecond.name,
      })
    }

    const onChangeItemNameOther = (
      name: string,
      itemChoice: { index: number; name: string; id: number },
    ): void => {
      onChangeItemName({
        ...itemChoice,
        name,
        id: 0,
        other: name,
      })
    }
    const onChangeItemNameOtherSecond = (
      name: string,
      itemChoiceSecond: { index: number; name: string; id: number },
    ): void => {
      onChangeItemNameSecond({
        ...itemChoiceSecond,
        name,
        id: 0,
        other: name,
      })
    }

    const onChangeSum = (sum: number) => {
      const newSpecialOfferReceipt = {
        ...props.specialOfferReceipt,
        sum,
      }
      context.emit('update:specialOfferReceipt', newSpecialOfferReceipt)
    }

    const onKeyupSum = async (e: any) => {
      if (e.isComposing) {
        return
      }
      e.target.value = e.target.value
        .replace(/[ー－]/g, '-')
        .replace(/[０-９]/g, (s: string) => {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
        })
        .replace(/[^-\d]/g, '')

      const sum = Number(e.target.value)
      if (isNaN(sum)) {
        return
      }
      onChangeSum(sum)
    }

    const importedToDisplay = computed(() => {
      return dateToDisplay(props.specialOfferReceipt.importedAt)
    })

    return {
      moment,
      state,
      chainStores,
      items,
      itemSeconds,
      onSelectChainStore,
      onChangeChainStoreOther,
      onChangeStoreName,
      onKeyupPhone,
      onSelectDateTime,
      onSelectItemName,
      onSelectItemNameSecond,
      onChangeItemNameOther,
      onChangeItemNameOtherSecond,
      onKeyupSum,
      importedToDisplay,
      UserRole,
    }
  },
})
